"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const embla_carousel_1 = __importDefault(require("embla-carousel"));
const embla_carousel_class_names_1 = __importDefault(require("embla-carousel-class-names"));
class ImageCarousel extends HTMLDivElement {
    constructor() {
        super();
        this.embla = (0, embla_carousel_1.default)(this, {
            align: 'start',
            containScroll: 'trimSnaps',
            inViewThreshold: 1,
            startIndex: 1,
        }, [
            (0, embla_carousel_class_names_1.default)({
                draggable: 'cursor-grab',
                dragging: 'cursor-grabbing',
            }),
        ]);
    }
}
exports.default = ImageCarousel;
